import { Button } from "@/components/ui/button/button";

import { useUpdateButton } from "./hooks/use-update-button";

export const HotelPolicyEditPageHeaderUpdateButton = () => {
	const { isValid, handleClick } = useUpdateButton();

	return (
		<Button variant={isValid ? "default" : "disabled"} size={"xl"} onClick={handleClick}>
			保存
		</Button>
	);
};
